import {connect} from 'react-redux'
import withRouter from "../../../../components/RouterComponentWrapper";
import PublicLiveViewNeu from "../../../../components/views/public/liveview/PublicLiveViewNeu";

const mapStateToProps = function (state, ownProps) {
    const urlParams = new URLSearchParams(ownProps.router.location.search);
    const tournamentId = urlParams.get('tournamentid');
    const eventOperatorId = urlParams.get('eventoperatorid');
    const boardId = urlParams.get('boardid');
    let isApp = urlParams.get('app');
    isApp = isApp !== null && isApp !== undefined && isApp.toUpperCase() === "TRUE";

    return {tournamentid: tournamentId, eventOperatorId: eventOperatorId, boardId: boardId, appCall: isApp};
};

const mapDispatchToProps = dispatch => ({
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PublicLiveViewNeu))
